const styles = theme => {
  // take mobile-first approach to do the styling
  const minSm = theme.breakpoints.up('sm');
  const minMd = theme.breakpoints.up('md');

  return {
    actionsRow: {
      marginTop: 50,
    },
    formButtons: {
      display: 'flex',

      '& > button': {
        flex: '1',
      },
      '& > button:first-child': {
        marginRight: 5,
      },
      '& > button:last-child': {
        marginLeft: 5,
      },
      [minMd]: {
        display: 'block',
        textAlign: 'right',

        '& > button': {
          width: 150,
          flex: 'none',
        },
      },
    },
    editButton: {
      width: '100%',
      [minMd]: {
        width: 150,
      },
    },
    formRow: {
      width: '100%',
      [minSm]: {
        display: 'flex',
        justifyContent: 'space-between',
      },
    },
    formGroup: {
      width: '100%',
      marginTop: 24,
    },
    halfFormGroup: {
      width: '100%',
      [minSm]: {
        width: '48%',
      },
    },
    textCenter: {
      textAlign: 'center',
    },
  };
};

export default styles;
